module.exports = __webpack_public_path__ + "img/home-solid.fa2c07da.svg";